import axiosInstance from "@/api/axiosInstance";

export class UserService {
  private readonly basePath: string;

  constructor(basePath = "/admin/users") {
    this.basePath = basePath;
  }

  public async getAll(): Promise<any> {
    try {
      const response = await axiosInstance.get(`/api/v1${this.basePath}`);
      return response.data;
    } catch (e: unknown) {
      console.log("users getall threw error", e);
    }
  }
}
